<template>
    <div id="modals">
        <EditBoardPane></EditBoardPane>
        <EditBoardLadder></EditBoardLadder>
        <EditBoardFixing></EditBoardFixing>
        <EditBoardHook></EditBoardHook>
        <EditBoardShelf></EditBoardShelf>
        <EditBoardModule></EditBoardModule>
        <EditBoardCaddy></EditBoardCaddy>
        <EditBoardSeparator></EditBoardSeparator>
        <EditGrid></EditGrid>
        <ExtendsPane></ExtendsPane>
        <EditPaper></EditPaper>
        <GenerateHooks></GenerateHooks>
        <MoveFixings key="moveFixing"></MoveFixings>
        <GenerateLadders
            v-if="datas"
            @close="visible = false;"
            :brandId="datas.brand.id"
            :zoneId="datas.zone && datas.zone.id"
            :zones="datas.zones && datas.zones.map(z => z.id)"
            :campaignId="datas.campaign && datas.campaign.id"
        ></GenerateLadders>
        <GenerateFixings
            v-if="datas"
            @close="visible = false;"
            :brandId="datas.brand.id"
            :zoneId="datas.zone && datas.zone.id"
            :zones="datas.zones && datas.zones.map(z => z.id)"
            :campaignId="datas.campaign && datas.campaign.id"
        ></GenerateFixings>
        <DisplayInfo key="displayInfo" v-if="datas && datas.id" :datas="datas"></DisplayInfo>
        <RenameFavorite key="renameFavorite" @rename="builder => $emit('rename-favorite', builder)"></RenameFavorite>
        <EditComment key="editComment" v-if="datas" :planoId="datas.id"></EditComment>
    </div>
</template>

<script>
import GenerateHooks from "./generate_hooks";
import GenerateFixings from "./generate_fixings";
import GenerateLadders from "./generate_ladders";
import EditBoardSeparator from "./edit_board_separator";
import EditBoardCaddy from "./edit_board_caddy";
import EditBoardHook from "./edit_board_hook";
import EditBoardShelf from "./edit_board_shelf";
import EditBoardModule from "./edit_board_module";
import EditBoardFixing from "./edit_board_fixing";
import EditBoardLadder from "./edit_board_ladder";
import EditBoardPane from "./edit_board_pane";
import EditComment from "./edit_comment";
import EditPaper from "./edit_paper";
import ExtendsPane from "./extends_pane";
import EditGrid from "./edit_grid";
import DisplayInfo from "./display_info";
import RenameFavorite from "./rename_favorite";
import MoveFixings from "./move_fixings";

export default {
    components: {
        GenerateHooks,
        GenerateFixings,
        GenerateLadders,
        EditBoardSeparator,
        EditBoardCaddy,
        EditBoardHook,
        EditBoardShelf,
        EditBoardModule,
        EditBoardFixing,
        EditBoardLadder,
        EditBoardPane,
        EditPaper,
        EditComment,
        EditGrid,
        ExtendsPane,
        DisplayInfo,
        RenameFavorite,
        MoveFixings
    },
    props: {
        datas: {
            type: Object,
            required: false
        }
    }
};
</script>

<style lang="scss">
.plano_modal {
    width: 100%;
    height: 100%;
    top: 0;
    position: fixed;
    .card {
        position: relative;
        width: 70%;
        margin: 0 auto;
        background: white;
        padding: 10px 20px;
        top: 30%;
    }
}
</style>
<style lang="scss" scoped>
#modals {
    > * {
        position: fixed;
        z-index: 2;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?265a865a